import ChekItOut from "../Common/ChekItOut";
import AepsOnboard from "../Views/Main/BankingService/AEPSICICI/AEPSONBOARD/index";
import Aeps from "../Views/Main/BankingService/AEPSICICI/AEPS/Aeps";
import GetRemitter from "../Views/Main/DMT/GetRemitter";
import KycForm from "../Views/Main/DMT/KycForm";
import RemitterReg from "../Views/Main/DMT/RemitterReg";
import Dashboard from "../Views/Main/Dashboard";
import Busticket from "../Views/Main/OtherServices/Bus/Busticket";
import Flights from "../Views/Main/OtherServices/Flights/Flight";
import Hotel from "../Views/Main/OtherServices/Hotel/Hotel";
import Verification from "../Views/Main/Payout/Verification";
import Profile from "../Views/Main/Profile";
import RechargeAndBill from "../Views/Main/Recharge&Bill";
import Uti from "../Views/Main/UTI";
import ProtectedAuth from "./PrivateAuth";
import EkycIndex from "../Views/Main/BankingService/AEPSICICI/AepsEkyc/EkycIndex";
import WithdrawalMoney from "../Views/Main/BankingService/AEPSICICI/AEPS/WithdrawalMoney";
import Addmembers from "../Views/Main/Members/Addmembers";
import { AepsCashWithdrawl } from "../ApiServices/Apifun";
import Ministatement from "../Views/Main/BankingService/AEPSICICI/AEPS/Ministatement";
import AadharPay from "../Views/Main/BankingService/AEPSICICI/AEPS/AadharPay";
import BalanceEnquiry from "../Views/Main/BankingService/AEPSICICI/AEPS/BalanceEnquiry";
import FundRequest from "../Views/Main/FundRequest/FundRequest";
import { Images } from "../Controller";
import Default from "./404";
import NotAvailable from "./NotAvailable";
import CashWithdrawlReport from "../Views/Main/Reports/CashwithdrwalReport";
import MiniStatementReport from "../Views/Main/Reports/MinistatementReport";
import AadharPayReport from "../Views/Main/Reports/AadharPayRepoer";
import PayoutReport from "../Views/Main/Reports/PayoutReport";
import RechargeReport from "../Views/Main/Reports/RechargeReport";
import BbpsReport from "../Views/Main/Reports/BbpsReports";
import DmtReport from "../Views/Main/Reports/DmtReport";
import UtiReport from "../Views/Main/Reports/UtiReport";
import WalletReport from "../Views/Main/Reports/WalletReport";
import FundRequestReport from "../Views/Main/Reports/FundRequestReport";
import Upi from "../Views/Main/UPI/Upi";
import KycStatus from "../Views/Main/Dashboard/KycStatus";
import ComingSoon from "./ComingSoon";
import MemberLists from "../Views/Main/Members/MemberList";
import ExpressPayout from "../Views/Main/ExpressPAyout/ExpressPayout";
import XpressPayoutReport from "../Views/Main/Reports/XpressPayoutReport";
import BalanceEnquireyReport from "../Views/Main/Reports/BalanceEnquireyReport";
import PanServices from "../Views/Main/PanServices";
import NsdlReport from "../Views/Main/Reports/NsdlReport";
import AepsYesOnboard from "../Views/Main/BankingService/AEPSYES/AEPSONBOARD";
import YesBankBioMetric from "../Views/Main/BankingService/AEPSYES/AepsEkyc/EkycIndex";
import YesBankAepsReport from "../Views/Main/Reports/YesBankAepsReport";
import AepsYesMainScreen from "../Views/Main/BankingService/AEPSYES/AEPS/Index";
import GiveTopup from "../Views/Main/GiveTopUp/GiveTopup";
import MainTab from "../Views/Main/Recharge&Bill/MainTab";
import Prepaid from "../Views/Main/Recharge&Bill/Prepaid";
import Memberkyc from "../Views/Main/BankingService/AEPSYES/MemberKyc/Memberkyc";
import MAtmReport from "../Views/Main/Reports/MAtmReport";
// import FlightBook from "../Views/Main/OtherServices/Flights/FlightBook";
// import FlightReport from "../Views/Main/Reports/FlightReport";
// import BookingDetail from "../Views/Main/OtherServices/Flights/BookingDetail";
// import BusBook from "../Views/Main/OtherServices/Bus/BusBook";
// import BusBookingDetail from "../Views/Main/OtherServices/Bus/BusBookingDetail";
// import BusReport from "../Views/Main/Reports/BusReport";
// import HotelBookPage from "../Views/Main/OtherServices/Hotel/HotelBook";
// import HotelReport from "../Views/Main/Reports/HotelReport";
// import Invoice from "../Views/Main/Invoice/Invoice";
import AepsCredo from "../Views/Main/BankingService/AepsCredo/AepsCredo";
import CredoAepsTransaction from "../Views/Main/Reports/CredoAepsTransaction";
// import CashDeposit from "../Views/Main/BankingService/AEPSICICI/AEPS/CashDeposit";
// import CashDepositReport from "../Views/Main/Reports/CashDepositReport";

import UpiForm from "../Views/Main/UPIDMT/UpiForm";
import UpiDmtReport from "../Views/Main/Reports/UpidmtReport";
import EkoPayout from "../Views/Main/Eko/Payout/EkoPayout";
import EkoPayoutReport from "../Views/Main/EkoReports/EkoPayoutReport";
import EkoQrReport from "../Views/Main/Eko/QrPayment/EkoQrReport";
import EkoBankVerification from "../Views/Main/Eko/BankVerification/EkoBankVerification";
import EkopanVerification from "../Views/Main/Eko/EkoPanVerification/EkoPanVerification";
import EkoCMS from "../Views/Main/Eko/CMS/EkoCMS";
import EkoAadharVerify from "../Views/Main/Eko/AadharVerify/EkoAadharVerify";
import EkoAadharReport from "../Views/Main/EkoReports/EkoAadharReport";
import EkoPanReport from "../Views/Main/EkoReports/EkoPanReport";
import EkoBankVerifyReport from "../Views/Main/EkoReports/EkoBankVerifyReport";
import EkoCmsReport from "../Views/Main/EkoReports/EkoCmsReport";
import EkoBBPS from "../Views/Main/Eko/BBPs/EkoBBPS";
import EkoBBPSOffline from "../Views/Main/Eko/BBPS Offline/EkoBBPSOffline";
import EkoBBPSofflineReport from "../Views/Main/EkoReports/EkoBBPSoffline";
import EkoBBPSReport from "../Views/Main/EkoReports/EkoBBPS";
import EkoCreditCard from "../Views/Main/Eko/CreditCard/EkoCreditCard";
import EkoCreditCardReport from "../Views/Main/EkoReports/EkoCreditCardReport";
import OperatorsCategory from "../Views/Main/Eko/BBPs/Opertors Category";
import OperatorsCategoryOffline from "../Views/Main/Eko/BBPS Offline/OperatorsCategoryOffline";
import EkoOnboardStatus from "../Views/Main/Eko/EkoOnboardStatus";
import DoMerchantOnboard from "../Views/Main/Eko/DoMerchantOnboard";
import PaymentService from "../Views/Main/PaymentService";
import GetCustomer from "../Views/Main/Eko/EkoDMT/GetCustomer";
import CustomerReg from "../Views/Main/Eko/EkoDMT/CustomerReg";
import EkoAepsOnboard from "../Views/Main/Eko/EkoAEPS/EkoAEPSONBOARD";
import Prepaid2 from "../Views/Main/Recharge&Bill/Recharge2";
import ChekItOut2 from "../Common/CheckItOut2";
import PartPayment from "../Views/Main/BBPSoffline/PartPayment";
import LeasePartPayment from "../Views/Main/BBPSoffline/LeasePartPayment";
import BawanaInfra from "../Views/Main/BBPSoffline/BawanaInfra";
import RemitterRegxPay from "../Views/Main/ExpressPAyout/RemitterRegxPay";
import GetRemitterXPay from "../Views/Main/XPayout/GetRemitterxPay";
import GetRemitterEkoXPay from "../Views/Main/Eko/EkoExpressPay/GetRemitterEkoXPay";
import EkoAeps from "../Views/Main/Eko/EkoAEPS/AEPS/Aeps";
import EkoEkycIndex from "../Views/Main/Eko/EkoAEPS/EkoAepsEkyc/EkycIndex";
import StaticQRreport from "../Views/Main/Eko/Static QR/StaticQRreport";
import SendMoneyModal from "../Views/Main/GiveTopUp/SendMoneyModal";
import DebitCreditFundReport from "../Views/Main/Members/DebitCreditFundReport";
import CommissionMemberReport from "../Views/Main/Reports/CommissionMemberReport";
import AepsBankingServiceMain from "../Views/Main/BankingService";
import BBPSServiceMain from "../Views/Main/BBPSmainTab";
import CMSServiceMain from "../Views/Main/CMSmainTab";
import DMTServiceMain from "../Views/Main/DMTmainTab";
import CreditcardServiceMain from "../Views/Main/CreditCardMainTab";
import RefundTransactionReport from "../Views/Main/Reports/RefundTransactionReport";
import GetRemitterxPayFusion from "../Views/Main/PayFusionXPayout/GetRemitterxPayFusion";
import PayfusionXpayoutReport from "../Views/Main/Reports/PayfusionXpayoutReport";
import ReportsMain from "../Views/Main/Reports/ReportsMain";
import LoginHistory from "../Views/Main/Reports/LoginHistory";
import UPIpayments from "../Views/Main/PaymentService/UPIpayments";
import UPIpaymentsReport from "../Views/Main/Reports/UPIpaymentsReport";
import CreditCardPayFusion from "../Views/Main/CreditCardMainTab/CreditCardPayFusion";
import BankVerifyReport from "../Views/Main/Reports/BankVerifyReport";
import ActiveDeactiveServices from "../Views/Main/Reports/ActiveDeactiveServices";
export const PrivateAuth = () => {
  return [
    {
      element: <ProtectedAuth />,
      children: [
        {
          path: "/Dashboard",
          element: <Dashboard />,
        },
        {
          path: "/kycStatus",
          element: <KycStatus />,
        },
        {
          path: "/ekoOnboardStatus",
          element: <EkoOnboardStatus />,
        },
        {
          path: "/doMerchantOnboard",
          element: <DoMerchantOnboard />,
        },
        {
          path: "/fundRequest",
          element: <FundRequest />,
        },
        {
          path: "/bbpsServiceMain",
          element: <BBPSServiceMain />,
        },
        {
          path: "/cmsServiceMain",
          element: <CMSServiceMain />,
        },
        // {
        //   path: "/dmtServiceMain",
        //   element: <DMTServiceMain />,
        // },
        {
          path: "/creditCardServiceMain",
          element: <CreditcardServiceMain />,
        },
        //BBPS OFFLINE ROUTES STARTED
        {
          path: "/BbpsOffline1/part_payment",
          element: <PartPayment />,
        },
        {
          path: "/BbpsOffline1/lease_part_payment",
          element: <LeasePartPayment />,
        },
        {
          path: "/BbpsOffline1/bawana_infra",
          element: <BawanaInfra />,
        },
        // RECHARGE ROUTES STARTED
        {
          path: "/recharge",
          element: <Prepaid />,
        },
        {
          path: "/recharge2",
          element: <Prepaid2 />,
        },
        {
          path: "/bbps",
          element: <RechargeAndBill />,
        },
        {
          path: "/checkOut",
          element: <ChekItOut />,
        },
        {
          path: "/checkOut2",
          element: <ChekItOut2 />,
        },
        // RECHARGE ROUTES ENDED
        // {
        //   path: "/transactionStatus",
        //   element: <TransactionSuccess />,
        // },

        //AEPS ROUTES STARTED
        // {
        //   path: "/banking/aeps-yesbank",
        //   element: <AepsYesMainScreen />,
        // },
        {
          path: "/aepsBankingServiceMain",
          element: <AepsBankingServiceMain />,
        },
        {
          path: "/banking/aeps2-2fa",
          element: <AepsCredo />,
        },
        {
          path: "/banking/waiting",
          element: <AepsCredo />,
        },
        {
          path: "/banking/aeps2-onboard",
          element: <AepsCredo />,
        },
        {
          path: "/banking/aeps-onboard",
          element: <AepsOnboard />,
        },
        {
          path: "/banking/aeps-eko-onboard",
          element: <EkoAepsOnboard />,
        },
        // {
        //   path: "/banking/aepsyes-memberkyc",
        //   element: <Memberkyc />,
        // },
        // {
        //   path: "/banking/aepsyes-onboard",
        //   element: <AepsYesOnboard />,
        // },
        {
          path: "/banking/aeps",
          element: <Aeps />,
        },
        {
          path: "/banking/aeps-eko",
          element: <EkoAeps />,
        },
        {
          path: "/banking/aeps-eko-ekyc",
          element: <EkoEkycIndex />,
        },
        {
          path: "/banking/aeps-ekyc",
          element: <EkycIndex />,
        },
        // {
        //   path: "/banking/aepsyes-ekyc",
        //   element: <YesBankBioMetric />,
        // },
        {
          path: "/banking/aeps-cash-withdrawl",
          element: <WithdrawalMoney />,
        },
        // {
        //   path: "/banking/aeps-cash-deposit",
        //   element: <CashDeposit />,
        // },
        {
          path: "/banking/aeps-aadharpay",
          element: <AadharPay />,
        },
        {
          path: "/banking/aeps-miniStatement",
          element: <Ministatement />,
        },
        {
          path: "/banking/aeps-balanceEnquiry",
          element: <BalanceEnquiry />,
        },
        //AEPS ROUTES ENDED
        // {
        //   path: "/upi",
        //   element: <Upi />,

        // },
        // {
        //   path: "/upi-dmt",
        //   element: <UpiForm />,
        // },
        //REPORTS ROUTES STARTED
        {
          path: "/Report_main",
          element: <ReportsMain />,
        },
        {
          path: "/Report/cash-transaction",
          element: <CredoAepsTransaction />,
        },
        // {
        //   path: "/Report/cash-deposit",
        //   element: <CashDepositReport />,
        // },
        {
          path: "/Report/cash-withdrawl",
          element: <CashWithdrawlReport />,
        },
        {
          path: "/Report/loginHistory",
          element: <LoginHistory />,
        },
        {
          path: "/active_deactive_services",
          element: <ActiveDeactiveServices />,
        },
        {
          path: "/Report/balance-enquirey",
          element: <BalanceEnquireyReport />,
        },
        {
          path: "/Report/Mini-statement",
          element: <MiniStatementReport />,
        },
        {
          path: "/Report/aadharpay",
          element: <AadharPayReport />,
        },
        {
          path: "/Report/payout",
          element: <PayoutReport />,
        },

        {
          path: "/Report/bbps",
          element: <BbpsReport />,
        },
        {
          path: "/Report/dmt",
          element: <DmtReport />,
        },
        {
          path: "/Report/uti",
          element: <UtiReport />,
        },
        {
          path: "/Report/bankVerify",
          element: <BankVerifyReport />,
        },
        {
          path: "/Report/wallet",
          element: <WalletReport />,
        },
        {
          path: "/Report/nsdl",
          element: <NsdlReport />,
        },
        {
          path: "/Report/fund-request",
          element: <FundRequestReport />,
        },
        {
          path: "/Report/xpressPayout",
          element: <XpressPayoutReport />,
        },
        // {
        //   path: "/Report/payfusion-xpressPayout",
        //   element: <PayfusionXpayoutReport />,
        // },
        // {
        //   path: "/Report/m-atm",
        //   element: <MAtmReport />,
        // },
        {
          path: "/Report/yesBank",
          element: <YesBankAepsReport />,
        },
        // {
        //   path: "/Report/upi-dmt",
        //   element: <UpiDmtReport />,
        // },
        // REPORTS ROUTES ENDED
        //Payment Routes
        {
          path: "/payment-service",
          element: <PaymentService />,
        },
        {
          path: "/pay-fusion/upiPayout",
          element: <UPIpayments />,
        },
        //Payment Routes Ended
        {
          path: "/pay_fusion/credit-card",
          element: <CreditCardPayFusion />,
        },
        //DMT ROUTES STARTED
        {
          path: "/dmt/submitKyc",
          element: <KycForm />,
        },
        {
          path: "/dmt/remitters",
          element: <GetRemitter />,
        },
        {
          path: "/dmt/addRemitters",
          element: <RemitterReg />,
        },
        //DMT ROUTES ENDED

        //PAYOUT ROUTE
        {
          path: "/payout/verification",
          element: <Verification />,
        },
        //express payout ROUTE
        {
          path: "/express-payout/get_remitter",
          element: <GetRemitterXPay />,
        },
        {
          path: "/express-payout/addRemitters",
          element: <RemitterRegxPay />,
        },
        //express payout ROUTE ENDED
        //PayFusionXPayout ROUTE
        {
          path: "/pay-fusion-express-payout/get_remitter",
          element: <GetRemitterxPayFusion />,
        },
        {
          path: "/pay-fusion-express-payout/addRemitters",
          element: <RemitterRegxPay />,
        },
        //PayFusionXPayout ROUTE Ended
        {
          path: "/eko/payout",
          element: <EkoPayout />,
        },
        {
          path: "/eko/qr",
          element: <EkoQrReport />,
        },
        {
          path: "/eko/static/qr",
          element: <StaticQRreport />,
        },
        {
          path: "/eko/bank-verify",
          element: <EkoBankVerification />,
        },
        {
          path: "/eko/pan-verify",
          element: <EkopanVerification />,
        },
        {
          path: "/eko/cms",
          element: <EkoCMS />,
        },
        {
          path: "/Report/eko/cms",
          element: <EkoCmsReport />,
        },
        {
          path: "/eko/credit-card",
          element: <EkoCreditCard />,
        },
        {
          path: "/eko/express-payout",
          element: <GetRemitterEkoXPay />,
        },
        {
          path: "/eko/aadhar-verify",
          element: <EkoAadharVerify />,
        },
        {
          path: "/eko/bbps-offline",
          element: <OperatorsCategoryOffline />,
        },
        {
          path: "/eko/bbps",
          element: <OperatorsCategory />,
        },
        {
          path: "/eko/dmt-service",
          element: <GetCustomer />,
        },
        {
          path: "/eko/dmt/addCustomers",
          element: <CustomerReg />,
        },
        {
          path: "/eko/ekoAepsMerchantOnboarding",
          element: <EkoAepsOnboard />,
        },
        // {
        //   path: "/eko/aeps-service",
        //   element: <EkoAEPS />,
        // },
        // {
        //   path: "/report/eko/payout",
        //   element: <EkoPayoutReport />,
        // },
        {
          path: "/report/eko/aadhar",
          element: <EkoAadharReport />,
        },
        {
          path: "/Report/eko/pan",
          element: <EkoPanReport />,
        },
        {
          path: "/report/eko/bankVerify",
          element: <EkoBankVerifyReport />,
        },
        // {
        //   path: "/Report/eko/bbps",
        //   element: <EkoBBPSReport />,
        // },
        {
          path: "/Report/eko/bbps-offline",
          element: <EkoBBPSofflineReport />,
        },
        {
          path: "/Report/eko/credit-card",
          element: <EkoCreditCardReport />,
        },
        {
          path: "/report/eko/payout",
          element: <EkoPayoutReport />,
        },
        {
          path: "/Report/commission_member",
          element: <CommissionMemberReport />,
        },
        {
          path: "/Report/refundTransaction",
          element: <RefundTransactionReport />,
        },
        {
          path: "/Report/upiPayments",
          element: <UPIpaymentsReport />,
        },
        {
          path: "/Report/recharge",
          element: <RechargeReport />,
        },
        // UTI ROUTE
        {
          path: "/uti",
          element: <Uti />,
        },
        {
          path: "/panServices",
          element: <PanServices />,
        },

        // {
        //   path: "/history/:id",
        //   element: <Invoice />,
        // },

        // TRAVEL ROUTES STARTED
        {
          path: "/flights",
          element: <Flights />,
        },
        {
          path: "/bus",
          element: <Busticket />,
        },
        {
          path: "/hotel",
          element: <Hotel />,
        },
        // TRAVEL ROUTES ENDED

        {
          path: "/personal-info",
          element: <Profile />,
        },
        {
          path: "/add-member",
          element: <Addmembers />,
        },
        {
          path: "/memberList",
          element: <MemberLists />,
        },
        {
          path: "/debit_credit_fund",
          element: <DebitCreditFundReport />,
        },
        // ERROR ROUTES
        {
          path: "/not-available",
          element: <NotAvailable />,
        },
        {
          path: "/coming-soon",
          element: <ComingSoon />,
        },
        {
          path: "*",
          element: <Default />,
        },
        {
          path: "/give-topup",
          element: <GiveTopup />,
        },
        {
          path: "/give_top_up_balanceTransfer",
          element: <SendMoneyModal />,
        },
        // ERROR ROUTES ENDED
      ],
    },
  ];
};
